// TermsPage.js
import React from "react";

function TermsPage() {
  return (
    <div className="container mt-5">
      <h2 className="mb-4">ข้อกำหนดการใช้งาน (Terms of Use)</h2>
      <p>
        เว็บไซต์นี้เป็นส่วนหนึ่งของบริการระบบแจ้งเตือน KSN2018 ซึ่งให้บริการเพื่อการรับรู้ภัยพิบัติและข้อมูลที่เกี่ยวข้อง เพื่อประโยชน์ของผู้ใช้และสาธารณะ
      </p>
      <ul>
        <li>ผู้ใช้ต้องไม่ใช้เว็บไซต์นี้เพื่อวัตถุประสงค์ที่ผิดกฎหมายหรือก่อให้เกิดอันตราย</li>
        <li>ทางผู้พัฒนาไม่รับประกันความถูกต้อง 100% ของข้อมูล และขอสงวนสิทธิในการเปลี่ยนแปลงระบบโดยไม่แจ้งล่วงหน้า</li>
        <li>การใช้งานเว็บไซต์นี้ถือว่าท่านยอมรับข้อกำหนดเหล่านี้โดยสมบูรณ์</li>
      </ul>
    </div>
  );
}

export default TermsPage;



